<template>
  <div class="calculator-box">
    <div class="input-box">
      <div class="item flex flex-col font-bold">
        <div>Price group</div>
        <select
          name="price-group"
          id="price-group"
          v-model="selectedGroup"
          class="regular bordered"
        >
          <option value="" disabled>select price group</option>
          <option
            v-for="group in priceGroups"
            :value="group.name"
            :key="group.name"
          >
            {{ group.name }}
          </option>
        </select>
      </div>
      <div class="item flex flex-col font-bold" v-if="selectedGroup != 'LP45'">
        <div>list price</div>
        <input
          type="number"
          v-model="listPrice"
          placeholder="list price"
          class="regular bordered"
        />
      </div>
      <div class="item flex flex-col font-bold" v-else>
        <div>Cost (list = {{ listPrice }})</div>
        <input
          type="number"
          v-model="cost"
          @keyup="updateCost"
          placeholder="cost"
          class="regular bordered"
        />
      </div>
      <div class="results">
        <div
          class="item text-center flex font-bold"
          v-if="listPrice !== 0 && selectedGroup !== ''"
        >
          <div>Retail</div>
          <div class="amount ml-4">
            {{ retail }}
          </div>
        </div>
        <div
          class="item text-center flex font-bold"
          v-if="listPrice !== 0 && selectedGroup !== ''"
        >
          <div>
            Repair shop
          </div>
          <div class="amount ml-4">
            {{ repairShop }}
          </div>
        </div>
        <div
          class="item text-center flex font-bold"
          v-if="listPrice !== 0 && selectedGroup !== ''"
        >
          <div>
            Wholesale
          </div>
          <div class="amount ml-4">
            {{ wholesale }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="selectedGroup === 'LP45'">
      *Dealer profit =
      <input
        @keyup="updateCost"
        type="number"
        step="0.01"
        name="dealer-profit"
        id="dealer-profit"
        v-model="dealerProfit"
        class="regular bordered"
      />
      cost with profit = {{ cost * dealerProfit }}
    </div>
  </div>
</template>
<script>
import {
  LP45_GROUP_NAME,
  calculateLp45ListPrice,
  calculateTiersFromListPrice
} from "@/utils/priceGroupCalculator.js";

export default {
  name: "PriceGroupCalculator",
  props: {
    priceGroups: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedGroup: "",
      listPrice: "",
      cost: "",
      dealerProfit: 1.1
    };
  },
  computed: {
    group() {
      return this.priceGroups.find(g => g.name === this.selectedGroup);
    },
    tiers() {
      if (!this.group) return null;
      return calculateTiersFromListPrice(this.listPrice, this.group);
    },
    retail() {
      return this.tiers ? this.tiers.online.toFixed(2) : "";
    },
    repairShop() {
      return this.tiers ? this.tiers.repairShop.toFixed(2) : "";
    },
    wholesale() {
      return this.tiers ? this.tiers.wholesale.toFixed(2) : "";
    }
  },
  methods: {
    updateCost() {
      if (this.selectedGroup !== LP45_GROUP_NAME) return;
      this.listPrice = calculateLp45ListPrice(
        this.cost,
        this.dealerProfit
      ).toFixed(2);
    }
  }
};
</script>
<style lang="postcss" scoped>
.calculator-box {
  margin: 10px 0px;
  border: 1px solid grey;
  padding: 10px 5px;
  border-radius: 4px;
  min-height: 60px;
  display: flex;
  flex-direction: column;
}
.input-box {
  display: grid;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.item {
  min-width: 150px;
}
.results {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  min-width: 300px;
}

@media screen and (max-width: 860px) {
  .item {
    margin: 10px 0px;
    min-width: 300px;
  }
  .results {
    flex-direction: column;
  }
  .results .item {
    @apply border rounded text-left justify-items-start flex-row flex;
    justify-content: space-between;
    padding: 15px;
  }
}
</style>
